module.exports = "/images/ao.svg?4d59685c9a88d13b98ac87497c42499a";